var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.indexPage,{attrs:{"parentData":{ grid: _setup.grid, path: _setup.path, grid_key: _setup.grid_key, report_class: _setup.report_class, report_namespace: _setup.report_namespace }},on:{"set-loading":_setup.setLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }